import React from "react";
import { FacebookShareButton, TwitterShareButton, LinkedinShareButton, EmailShareButton } from "react-share";
import classNames from "classnames";

interface ISocialShareLinks {
  className?: string;
  url: string;
  isAmp: boolean;
}

const SocialShareLinks = (props: ISocialShareLinks): JSX.Element => {
  const { isAmp, url: shareUrl, className } = props,
    classes = classNames("social-share-links-comp", className);

  return (
    <ul className={classes}>
      <li className="">
        {isAmp ? (
          <amp-social-share type="facebook" width="40" height="40" data-param-url={shareUrl} aria-label="Share on Facebook"></amp-social-share>
        ) : (
          <FacebookShareButton className="social-link" url={shareUrl}>
            <i className="fab fa-facebook-f"></i>
          </FacebookShareButton>
        )}
      </li>
      <li className="">
        {isAmp ? (
          <amp-social-share type="twitter" width="40" height="40" data-param-url={shareUrl} aria-label="Share on Twitter"></amp-social-share>
        ) : (
          <TwitterShareButton className="social-link" url={shareUrl}>
            <i className="fab fa-twitter"></i>
          </TwitterShareButton>
        )}
      </li>
      <li className="">
        {isAmp ? (
          <amp-social-share type="linkedin" width="40" height="40" data-param-url={shareUrl} aria-label="Share on LinkedIn"></amp-social-share>
        ) : (
          <LinkedinShareButton className="social-link" url={shareUrl}>
            <i className="fab fa-linkedin-in"></i>
          </LinkedinShareButton>
        )}
      </li>
      <li className="">
        {isAmp ? (
          <amp-social-share type="email" width="40" height="40" data-param-url={shareUrl} aria-label="Share on Email"></amp-social-share>
        ) : (
          <EmailShareButton className="social-link" url={shareUrl}>
            <i className="fa fa-envelope"></i>
          </EmailShareButton>
        )}
      </li>
    </ul>
  );
};

export default SocialShareLinks;
